import {
    UPDATE_REGISTER_EMAIL,
    UPDATE_REGISTER_PASSWORD,
    UPDATE_REGISTER_ORGANIZATION_NAME,
    UPDATE_REGISTER_FIRST_NAME,
    UPDATE_REGISTER_MIDDLE_NAME,
    UPDATE_REGISTER_LAST_NAME,
    UPDATE_REGISTER_INVITE_CODE,
    UPDATE_REGISTER_STAFF_INVITE_CODE,

    REGISTER_ATTEMPT,
    REGISTER_SUCCEEDED,
    REGISTER_FAILED,
    REGISTER_RESET,
} from 'shared_redux/actions';

const createDefaultState = () => ({
    email: "",
    password: "",
    organization_name: "",
    firstName: "",
    middleName: "",
    lastName: "",
    inviteCode: "",
    staffInviteCode: "",
    registered: false,
    registering: false,
    account_id: "",
    is_active: false,
});

export default (state = createDefaultState(), action) => {
    switch (action.type) {
        case UPDATE_REGISTER_EMAIL:
            return {
                ...state,
                email: action.email,
            };
        case UPDATE_REGISTER_PASSWORD:
            return {
                ...state,
                password: action.password,
            };
        case UPDATE_REGISTER_ORGANIZATION_NAME:
            return {
                ...state,
                organization_name: action.organization_name,
            };
        case UPDATE_REGISTER_FIRST_NAME:
            return {
                ...state,
                firstName: action.firstName,
            };
        case UPDATE_REGISTER_MIDDLE_NAME:
            return {
                ...state,
                middleName: action.middleName,
            };
        case UPDATE_REGISTER_LAST_NAME:
            return {
                ...state,
                lastName: action.lastName,
            };
        case UPDATE_REGISTER_INVITE_CODE:
            return {
                ...state,
                inviteCode: action.inviteCode,
            };
        case UPDATE_REGISTER_STAFF_INVITE_CODE:
            return {
                ...state,
                staffInviteCode: action.staffInviteCode,
            };
        case REGISTER_ATTEMPT:
            return {
                ...state,
                registering: true,
            };
        case REGISTER_SUCCEEDED:
            return {
                ...state,
                registering: false,
                registered: true,
                account_id: action.payload?.account_id || "",
                is_active: action.payload?.is_active || false,
            };
        case REGISTER_FAILED:
            return {
                ...state,
                registering: false,
            };
        case REGISTER_RESET:
            return createDefaultState();
        default:
            return state;
    }
};
